import React, { useEffect, useState } from 'react';
import MessageBox from '../MessageBox';
import '../../../sass/components/floating_message_box.scss';

const FloatingMessageBox = ({ children, close, ariaLive }) => {
  const [isOpen, updateIsOpen] = useState<boolean>(false);
  const [isClosing, setIsClosing] = useState<boolean>(false);
  function closeBox() {
    return setIsClosing(true);
  }
  useEffect(() => {
    const openFunction = setTimeout(() => updateIsOpen(true), 1);
    const closeFunction = setTimeout(() => closeBox(), 4000);
    document.addEventListener('click', closeBox);
    return () => {
      document.removeEventListener('click', closeBox);
      clearTimeout(openFunction);
      clearTimeout(closeFunction);
    };
  }, []);
  useEffect(() => {
    updateIsOpen(false);
    const closeFunction = setTimeout(() => (isClosing ? close() : null), 300);
    return () => clearTimeout(closeFunction);
  }, [isClosing, close]);
  return (
    <div
      aria-live={ariaLive}
      className={`floating-message-box${
        isOpen ? ' floating-message-box--open' : ''
      }`}
    >
      <div className="floating-message-box__message-box">
        <MessageBox type={'success'}>{children}</MessageBox>
      </div>
    </div>
  );
};

export default FloatingMessageBox;
